var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('span',{class:['badge-container',_vm.type]},[_vm._t("default"),_vm._v(" "),_c('span',{class:['badge',_vm.type]},[_vm._v("\n    "+_vm._s(_vm.value)+"\n    ")])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }